import { CaretRightFilled, CloseCircleOutlined, CrownOutlined, PlusOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import * as BenefitApi from '../../../api/rank/benefitApi';
import { gold_image, Icon_Wrapper, info_cicrle, noData } from "../../../components/ExportImgFigma";
import RightPopup from "../../../components/Popup/RightPopup";
import { URL_RANK } from "../../../env";
import './ShowRank.scss';
import { Button, Collapse, Tabs, Tooltip } from "antd";
import BenefitCard from "./BenefitCard";
import { IInfoCarePolicie } from "../../../api/rank/rankApi";
import { capitalizeEachWord } from "../../../until";


type Benefit = {
  id: number;
  title: string;
  description: string;
};

type BenefitGroup = {
  key: string;
  label: string;
  data: Benefit[];
};


const benefitGroups: BenefitGroup[] = [

  {
    key: "policy",
    label: "Quyền lợi chính sách chăm sóc khách hàng",
    data: [
      {
        id: 3,
        title: "Tặng thêm 10% tích lũy điểm thưởng tại các đơn vị liên kết",
        description: " Lorem ipsum dolor sit amet consectetur adipisicing elit. Laboriosam ad quibusdam debitis sed quae hic architecto id numquam magnam earum voluptas, illo fuga molestiae voluptates in labore eveniet facilis perferendis?",
      },
    ],
  },
];


const { Panel } = Collapse;
// export interface IInfoCarePolicie {
//   id: number
//   code: string
//   title: string
//   benefitPolicies: Array<{
//     id: number
//   }>
//   categoryCar: Array<{
//     id: number
//     code: string
//     title: string
//   }>
//   car: Array<{
//     id: number
//     code: string
//     title: string
//   }>
// }
interface Props {
  className?: string;
  onClose?: () => void;
  dataCarePolicie?: IInfoCarePolicie
}

const ShowPolicies: React.FC<Props> = ({ className, dataCarePolicie, onClose }) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const toggle = (id: number) => {
    setSelectedIds(prev =>
      prev.includes(id)
        ? prev.filter(x => x !== id)
        : [...prev, id]
    );
  };


  const handleOnClose = () => {
    if (onClose) {
      onClose()
    }
  }

  return (
    <RightPopup
      title="Chi tiết"
      className={className}
      contentClassName="user-card-popup__content"
      onClose={handleOnClose}
    >
      <div className="rank-detail-block">
        <div className="name-detail-rank custom-page-css flex flex-col">
          <div className="custom-page-css flex flex-col ">
            <span className="custom-page-css font-bold rank-detail-label text-base">{dataCarePolicie?.title}</span>
          </div>
          <div className=" custom-page-css flex items-center justify-between w-full gap-2">
            <span className="custom-page-css text-sm text-475467">Áp dụng cho thương hiệu: </span>

            <Tooltip
              placement="right"
              color="white"
              title={
                <div
                  style={{
                    maxHeight: 400,       // chiều cao cố định
                    overflowY: "auto",    // bật scroll dọc
                  }}
                  className="space-y-2"
                >
                  {
                    dataCarePolicie?.categoryCar?.map((item: any, i: any) => (
                      <div key={i} className="flex items-center gap-2">
                        <span className="color-bage-custom fs-14">

                          {capitalizeEachWord(item.title)}
                        </span>
                      </div>
                    ))
                  }
                </div>
              }
            >
              <div className="custom-page-css flex items-center gap-2">
                {dataCarePolicie?.categoryCar?.length} thương hiệu
                <div className="action-icons action-icons-bage-2  px-2 fs-14 cursor-pointer ml-1">

                  <img src={info_cicrle} alt="Avatar" />
                </div>
              </div>
            </Tooltip>

          </div>
          <div className=" custom-page-css flex items-center justify-between w-full gap-2">
            <span className="custom-page-css text-sm text-475467">Áp dụng cho tên xe: </span>

            <Tooltip
              placement="right"
              color="white"
              title={
                <div
                  style={{
                    maxHeight: 400,       // chiều cao cố định
                    overflowY: "auto",    // bật scroll dọc
                  }}
                  className="space-y-2"
                >
                  {
                    dataCarePolicie?.car?.map((item: any, i: any) => (
                      <div key={i} className="flex items-center gap-2">
                        <span className="color-bage-custom fs-14">

                          {capitalizeEachWord(item.title)}
                        </span>
                      </div>
                    ))
                  }
                </div>
              }
            >
              <div className="custom-page-css flex items-center gap-2">
                {dataCarePolicie?.car?.length} tên xe
                <div className="action-icons action-icons-bage-2  px-2 fs-14 cursor-pointer ml-1">

                  <img src={info_cicrle} alt="Avatar" />
                </div>
              </div>
            </Tooltip>

          </div>
          <div className=" custom-page-css flex items-center justify-between w-full gap-2">
            <span className="custom-page-css text-sm text-475467">Ngày bắt đầu: </span>

            <div className="custom-page-css flex items-center gap-2">
              {dataCarePolicie?.dateStart}
            </div>
          </div>
          <div className=" custom-page-css flex items-center justify-between w-full gap-2">
            <span className="custom-page-css text-sm text-475467">Ngày kết thúc: </span>

            <div className="custom-page-css flex items-center gap-2">
              {dataCarePolicie?.dateEnd}
            </div>
          </div>
        </div>
      </div>
      <div className="detail-block t-mt-0">
        <Tabs
          defaultActiveKey={'1'}
          items={[
            {
              key: '2',
              label: <span className='text-base font-regular'>Quyền lợi chính sách chăm sóc khách hàng ({dataCarePolicie?.benefitPolicies.length})</span>,
              children:
                <div className="custom-page-css benefit-block">
                  {/* <div className="benefit-block__title font-bold">Quyền lợi hạng</div> */}
                  <Collapse defaultActiveKey={["hang"]} ghost expandIcon={({ isActive }) => (
                    <CaretRightFilled

                      rotate={isActive ? 90 : 0}
                      style={{ fontSize: 14, color: "#8E8E8E" }}
                    />
                  )}
                  >
                    <div className="benefit-list" >
                      {
                        dataCarePolicie && dataCarePolicie.benefitPolicies.length > 0 ?
                          dataCarePolicie?.benefitPolicies.map(item => (
                            <BenefitCard
                              key={item.id}
                              item={item}
                              selected={selectedIds.includes(item.id)}
                              onToggle={toggle}
                            />
                          ))
                          :
                          <div
                            style={{
                              textAlign: 'center',
                              padding: 20
                            }}>
                            <br />
                            <img src={noData} alt="No data"

                              style={{
                                maxWidth: 150,
                              }} />
                            <br />
                            <div>Không có dữ liệu</div>
                            <br />
                          </div>
                      }
                    </div>
                  </Collapse>
                  {/* <div className="benefit-card">
          {dataCarePolicie?.listBenefit.map((item, index) => (
            <div className="item" key={index}>
              <CrownOutlined />
              <span className="neutral-gray-500">{item.description}</span>
            </div>
          ))}
        </div> */}
                </div>
            }
          ]} />


      </div>

    </RightPopup>
  )
}

export default ShowPolicies